import { useEffect, useRef, useState } from 'react';
import CoinImage from '../../assets/icons/punch/coin.png';

const formatScorePoint = (value) => Number(value ?? 0).toLocaleString('ko-KR');

export default function PunchPrizePoolSummary({ isBurningActive, scoreValue }) {
  const [displayScoreValue, setDisplayScoreValue] = useState(Math.round(Number(scoreValue ?? 0)));
  const displayScoreValueRef = useRef(Math.round(Number(scoreValue ?? 0)));

  useEffect(() => {
    displayScoreValueRef.current = displayScoreValue;
  }, [displayScoreValue]);

  useEffect(() => {
    const target = Math.round(Number(scoreValue ?? 0));
    if (!Number.isFinite(target)) return undefined;
    if (displayScoreValueRef.current === target) return undefined;

    const start = displayScoreValueRef.current;
    const totalTicks = 10;
    let tick = 0;

    const timer = window.setInterval(() => {
      tick += 1;
      if (tick >= totalTicks) {
        window.clearInterval(timer);
        setDisplayScoreValue(target);
        return;
      }

      const progress = tick / totalTicks;
      setDisplayScoreValue(Math.max(0, Math.round(start + (target - start) * progress)));
    }, 42);

    return () => {
      window.clearInterval(timer);
    };
  }, [scoreValue]);

  return (
    <section
      className="relative z-[3] mt-5 flex w-[276px] flex-col items-center gap-[6px]"
      aria-label="마이냥스코어 정보"
    >
      <div className="flex items-center gap-[4px]">
        <img src={CoinImage} alt="코인" className="h-[20px] w-[20px] object-cover mb-0.5" />
        <p
          className={`m-0 font-['Pretendard'] text-xs font-bold leading-[1.3] ${
            isBurningActive ? 'text-[#FFE8D9]' : 'text-[#666666]'
          }`}
        >
          내 총 누적포인트
        </p>
      </div>
      <div className="flex items-end gap-[4px]">
        <p
          className={`m-0 font-['Pretendard'] text-[36px] font-extrabold leading-none tracking-[-1.08px] ${
            isBurningActive ? 'text-white' : 'text-gray05'
          }`}
        >
          {formatScorePoint(displayScoreValue)}
        </p>
        <span
          className={`font-['Pretendard'] text-[15px] font-extrabold leading-none ${
            isBurningActive ? 'text-white' : 'text-gray05'
          }`}
        >
          P
        </span>
      </div>
    </section>
  );
}
